module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-layer"
  }, [_c('div', {
    staticClass: "container "
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("事故车推送")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "topInfo"
  }, [_c('span', {
    staticClass: "mr26"
  }, [_c('i', {
    staticClass: "sign mr8"
  }, [_vm._v("*")]), _vm._v("所属公司：" + _vm._s(_vm.sendData.companyName))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "sign mr8"
  }, [_vm._v("*")]), _vm._v("公司ID：" + _vm._s(_vm.sendData.companyId))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "infoZone"
  }, [_c('p', [_vm._v("您好，这里是救援大师调度中心，今天往贵店新推送了一辆事故车，信息如下：")]), _vm._v(" "), _c('p', [_vm._v("车牌号：" + _vm._s(_vm.sendData.carNumer))]), _vm._v(" "), _c('p', [_vm._v("车辆品牌：" + _vm._s(_vm.sendData.carBrandName))]), _vm._v(" "), _c('p', [_vm._v("车主姓名：" + _vm._s(_vm.sendData.carOwnerName))]), _vm._v(" "), _c('p', [_vm._v("车主电话：" + _vm._s(_vm.sendData.carOwnerPhone))]), _vm._v(" "), _c('p', [_vm._v("请及时联系客户，并反馈沟通结果，方便后续跟进，谢谢！")]), _vm._v(" "), _c('p', [_vm._v("订单详情：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.link))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.code),
      expression: "code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }]
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sendInfo"
  }, [_c('span', [_c('i', {
    staticClass: "sign mr8"
  }, [_vm._v("*")]), _vm._v("推送信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5995f812","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sendMask.vue
// module id = 4dTi
// module chunks = 6